"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GeometryManagerHelper_drawingToolsManager, _GeometryManagerHelper_eventEngine, _GeometryManagerHelper_geometryManager, _GeometryManagerHelper_geometryState, _GeometryManagerHelper_viewport;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeometryManagerHelper = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const gl_matrix_1 = require("gl-matrix");
class GeometryManagerHelper {
    // #endregion Properties (4)
    // #region Constructors (1)
    constructor(drawingToolsManager, geometryManager, geometryState) {
        // #region Properties (4)
        _GeometryManagerHelper_drawingToolsManager.set(this, void 0);
        _GeometryManagerHelper_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _GeometryManagerHelper_geometryManager.set(this, void 0);
        _GeometryManagerHelper_geometryState.set(this, void 0);
        _GeometryManagerHelper_viewport.set(this, void 0);
        __classPrivateFieldSet(this, _GeometryManagerHelper_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _GeometryManagerHelper_geometryManager, geometryManager, "f");
        __classPrivateFieldSet(this, _GeometryManagerHelper_geometryState, geometryState, "f");
        __classPrivateFieldSet(this, _GeometryManagerHelper_viewport, drawingToolsManager.viewport, "f");
    }
    // #endregion Constructors (1)
    // #region Public Methods (6)
    addPoint(insertionIndex, position, metaData, temporary = false) {
        const positionArrayLength = __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.length / 3;
        if (positionArrayLength === 0 && !position)
            return false;
        const scaledIndex = insertionIndex * 3;
        if (insertionIndex < 0 || insertionIndex > positionArrayLength) {
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError("The insertion index is out of range. Please provide a valid index.");
        }
        const newPositionArray = new Float32Array(__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.length + 3);
        let p;
        if (position) {
            p = position;
        }
        else if (insertionIndex === 0) {
            p = [
                __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex + 0),
                __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex + 1),
                __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex + 2),
            ];
        }
        else if (insertionIndex === positionArrayLength) {
            p = [
                __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex - 3),
                __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex - 2),
                __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex - 1),
            ];
        }
        else {
            const p1 = gl_matrix_1.vec3.fromValues(__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex + 0), __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex + 1), __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex + 2));
            const p2 = gl_matrix_1.vec3.fromValues(__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex + 3), __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex + 4), __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.at(scaledIndex + 5));
            p = gl_matrix_1.vec3.div(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), p2, p1), gl_matrix_1.vec3.fromValues(2, 2, 2));
            // get neighboring point and calculate center
        }
        // Apply constraints. Pass positionArrayLength as pointIndex so that all
        // existing points are treated as "other" points (the new point is not yet
        // in the array).
        p = __classPrivateFieldGet(this, _GeometryManagerHelper_drawingToolsManager, "f").applyConstraints(p, positionArrayLength);
        newPositionArray.set([
            ...__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.slice(0, scaledIndex),
            ...p,
            ...__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.slice(scaledIndex, __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.length),
        ]);
        // adjust metadata array
        const newMetaDataArray = __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").metadataArray.slice();
        newMetaDataArray.splice(insertionIndex, 0, metaData || undefined);
        // set the material index at that point to 0 and move the other indices back
        const materialIndexArray = __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").materialIndexArray
            .slice(0, insertionIndex)
            .concat([0], __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").materialIndexArray.slice(insertionIndex, __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").materialIndexArray.length - 1));
        __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").updateMaterialIndexArray(materialIndexArray);
        __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").updateData(newPositionArray, newMetaDataArray, temporary);
        __classPrivateFieldGet(this, _GeometryManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.ADDED, {
            viewportId: __classPrivateFieldGet(this, _GeometryManagerHelper_viewport, "f").id,
            drawingToolsId: __classPrivateFieldGet(this, _GeometryManagerHelper_geometryManager, "f").parentNode.id,
            temporary,
            index: insertionIndex,
        });
        return true;
    }
    movePoint(index, point, metaData, temporary = false, skipConstraints) {
        if (!skipConstraints) {
            point = __classPrivateFieldGet(this, _GeometryManagerHelper_drawingToolsManager, "f").applyConstraints(point, index);
        }
        const threeJsPointsGeometry = __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f")
            .geometryDataPoints.convertedObject[__classPrivateFieldGet(this, _GeometryManagerHelper_viewport, "f").id];
        threeJsPointsGeometry.geometry.attributes["position"].setXYZ(index, point[0], point[1], point[2]);
        threeJsPointsGeometry.geometry.attributes["position"].needsUpdate =
            true;
        if (__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").geometryDataLines) {
            const threeJsLinesGeometry = __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f")
                .geometryDataLines.convertedObject[__classPrivateFieldGet(this, _GeometryManagerHelper_viewport, "f").id];
            threeJsLinesGeometry.geometry.attributes["position"].setXYZ(index, point[0], point[1], point[2]);
            threeJsLinesGeometry.geometry.attributes["position"].needsUpdate =
                true;
        }
        // update the metadata at that index (even if temporary)
        __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").metadataArray[index] = metaData;
        if (temporary === false) {
            const metadataArray = __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").metadataArray.slice();
            // adjust position array
            const positionArray = new Float32Array(__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray);
            positionArray.set([
                ...positionArray.slice(0, index * 3),
                ...point,
                ...positionArray.slice(index * 3 + 3, positionArray.length),
            ]);
            __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").updateData(positionArray, metadataArray, temporary);
        }
        __classPrivateFieldGet(this, _GeometryManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MOVED, {
            viewportId: __classPrivateFieldGet(this, _GeometryManagerHelper_viewport, "f").id,
            drawingToolsId: __classPrivateFieldGet(this, _GeometryManagerHelper_geometryManager, "f").parentNode.id,
            temporary,
            index,
        });
    }
    removePoint(removalIndex, temporary = false) {
        const positionArrayLength = __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.length / 3;
        if (removalIndex < 0 || removalIndex >= positionArrayLength) {
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError("The removal index is out of range. Please provide a valid index.");
        }
        /**
         * Adjust the position attribute
         *
         * Logic:
         *  - remove :D
         */
        const newPositionArray = new Float32Array(__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.length - 3);
        const metadataArray = __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").metadataArray.slice();
        if (removalIndex > 0 && removalIndex < positionArrayLength) {
            newPositionArray.set([
                ...__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.slice(0, Math.max(removalIndex, 0) * 3),
                ...__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.slice(Math.min(removalIndex + 1, __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.length) * 3, __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.length),
            ]);
            metadataArray.splice(removalIndex, 1);
        }
        else if (removalIndex === 0) {
            newPositionArray.set(__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.slice(3, __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.length));
            metadataArray.splice(0, 1);
        }
        else {
            newPositionArray.set(__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.slice(0, __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray.length - 3));
            metadataArray.splice(removalIndex, 1);
        }
        // remove the material index at that point and move the other indices one forward
        const materialIndexArray = __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").materialIndexArray
            .slice(0, removalIndex)
            .concat(__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").materialIndexArray.slice(removalIndex + 1, __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").materialIndexArray.length));
        // add a 0 at the end
        materialIndexArray.push(0);
        __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").updateMaterialIndexArray(materialIndexArray);
        __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").updateData(newPositionArray, metadataArray, temporary);
        __classPrivateFieldGet(this, _GeometryManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.REMOVED, {
            viewportId: __classPrivateFieldGet(this, _GeometryManagerHelper_viewport, "f").id,
            drawingToolsId: __classPrivateFieldGet(this, _GeometryManagerHelper_geometryManager, "f").parentNode.id,
            temporary,
            index: removalIndex,
        });
        return true;
    }
    removePoints(indices) {
        // sort indices so that highest is first
        indices.sort((a, b) => b - a);
        let positionArray = new Float32Array(__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").positionArray);
        let materialIndexArray = __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").materialIndexArray;
        let metadataArray = __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").metadataArray.slice();
        for (const removalIndex of indices) {
            const positionArrayLength = positionArray.length / 3;
            if (removalIndex < 0 || removalIndex >= positionArrayLength) {
                throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError("The removal index is out of range. Please provide a valid index.");
            }
            /**
             * Adjust the position attribute
             *
             * Logic:
             *  - remove :D
             */
            const newPositionArray = new Float32Array(positionArray.length - 3);
            if (removalIndex > 0 && removalIndex < positionArrayLength) {
                newPositionArray.set([
                    ...positionArray.slice(0, Math.max(removalIndex, 0) * 3),
                    ...positionArray.slice(Math.min(removalIndex + 1, positionArray.length) * 3, positionArray.length),
                ]);
                metadataArray.splice(removalIndex, 1);
            }
            else if (removalIndex === 0) {
                newPositionArray.set(positionArray.slice(3, positionArray.length));
                metadataArray.splice(0, 1);
            }
            else {
                newPositionArray.set(positionArray.slice(0, positionArray.length - 3));
                metadataArray.splice(removalIndex, 1);
            }
            positionArray = newPositionArray;
            materialIndexArray = materialIndexArray
                .slice(0, removalIndex)
                .concat(materialIndexArray.slice(removalIndex + 1, materialIndexArray.length));
            // add a 0 at the end
            materialIndexArray.push(0);
        }
        __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").updateMaterialIndexArray(materialIndexArray);
        __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").updateData(positionArray, metadataArray);
        __classPrivateFieldGet(this, _GeometryManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.REMOVED, {
            viewportId: __classPrivateFieldGet(this, _GeometryManagerHelper_viewport, "f").id,
            drawingToolsId: __classPrivateFieldGet(this, _GeometryManagerHelper_geometryManager, "f").parentNode.id,
            temporary: false,
            index: indices,
        });
    }
    resetMaterialIndices() {
        __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").updateMaterialIndexArray(new Array(1024).fill(0));
    }
    updateMaterialIndex(index, materialIndex) {
        // change material index
        if (__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").materialIndexArray[index] !== materialIndex) {
            __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").materialIndexArray[index] = materialIndex;
            __classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").updateMaterialIndexArray(__classPrivateFieldGet(this, _GeometryManagerHelper_geometryState, "f").materialIndexArray);
        }
    }
}
exports.GeometryManagerHelper = GeometryManagerHelper;
_GeometryManagerHelper_drawingToolsManager = new WeakMap(), _GeometryManagerHelper_eventEngine = new WeakMap(), _GeometryManagerHelper_geometryManager = new WeakMap(), _GeometryManagerHelper_geometryState = new WeakMap(), _GeometryManagerHelper_viewport = new WeakMap();
//# sourceMappingURL=GeometryManagerHelper.js.map